import type { MainPoint, SubPoint } from "../../../../types/global"
import { api } from "../../api"

export async function loadNavigation(): Promise<Navigation[]> {
    let navigations = await api<Navigation[]>("navigation", {})
    console.log(navigations)
    return navigations.data
}
